import { QuerySignalsState } from '../../../models';
import { QUERY_SIGNALS_MUTATIONS_KEYS } from '../query-signals.const';
import { QuerySignalsMutation } from '../query-signals.interfaces';

export class ClearQuerySignalsMutation implements QuerySignalsMutation {
  mutations = {
    [QUERY_SIGNALS_MUTATIONS_KEYS.clearNextQueriesState]: (querySignalsState: QuerySignalsState) => {
      querySignalsState.nextQueries = [];
      querySignalsState.nextQueriesQuery = '';
      querySignalsState.lastNextQueryLoaded = null;
    },
    [QUERY_SIGNALS_MUTATIONS_KEYS.clearRelatedTags]: (querySignalsState: QuerySignalsState) => {
      querySignalsState.relatedTags = [];
    },
    [QUERY_SIGNALS_MUTATIONS_KEYS.deselectRelatedTags]: (querySignalsState: QuerySignalsState) => {
      querySignalsState.relatedTags.forEach(rt => rt.selected = false);
    }
  };
}
